import { classNames } from "../../components/utils/Utils";

const CustomSoundStatusPill = (props) => {
    const status = props.value ? props.value.toLowerCase() : "unknown";
    return (
        <span
            className={classNames(
                "px-3 py-1 uppercase leading-wide font-bold text-xs rounded-full shadow-sm",
                status.startsWith("requested") ? "bg-yellow-100 text-yellow-700" : null,
                status.startsWith("prepared") ? "bg-green-100 text-green-700" : null,
                status.startsWith("converted") ? "bg-green-100 text-green-700" : null,
                status.startsWith("exported") ? "bg-green-100 text-green-700" : null,
                status.startsWith("completed") ? "bg-blue-100 text-blue-700" : null,
                status.startsWith("failed") ? "bg-red-100 text-red-700" : null,
            )}
        >{status.replaceAll("_", " ")}</span>
    );
}

export default CustomSoundStatusPill